module.exports = __webpack_public_path__ + "img/second-section-2.b045b58c.jpg";